import { render } from "./block.vue?vue&type=template&id=abc63ab8&scoped=true"
import script from "./block.vue?vue&type=script&lang=js"
export * from "./block.vue?vue&type=script&lang=js"

import "./block.vue?vue&type=style&index=0&id=abc63ab8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abc63ab8"]])

export default __exports__